import React, { useState } from 'react';
import './CreateEmployeeIndex.css';

const CreateEmployeeIndex = ({ onCancel }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    middleName: '',
    lastName: '',
    employeeId: '',
    emailId: '',
    employeeStatus: '',
  });

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleCreate = () => {
    console.log('Creating employee:', formData);
    // Add create logic here
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <div className="create-employee-container">
      <div className="create-employee-card">
        {/* Row 1: Names */}
        <div className="form-row">
          <div className="form-group">
            <label className="form-label">First Name</label>
            <input
              type="text"
              className="form-input"
              value={formData.firstName}
              onChange={(e) => handleChange('firstName', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Middle Name</label>
            <input
              type="text"
              className="form-input"
              value={formData.middleName}
              onChange={(e) => handleChange('middleName', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Last Name</label>
            <input
              type="text"
              className="form-input"
              value={formData.lastName}
              onChange={(e) => handleChange('lastName', e.target.value)}
            />
          </div>
        </div>

        {/* Row 2: Employee Details */}
        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Employee Id</label>
            <input
              type="text"
              className="form-input"
              value={formData.employeeId}
              onChange={(e) => handleChange('employeeId', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Email Id</label>
            <input
              type="email"
              className="form-input"
              value={formData.emailId}
              onChange={(e) => handleChange('emailId', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Employee Status</label>
            <input
              type="text"
              className="form-input"
              value={formData.employeeStatus}
              onChange={(e) => handleChange('employeeStatus', e.target.value)}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="form-actions">
          <button className="btn-create" onClick={handleCreate}>
            Create
          </button>
          <button className="btn-cancel" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateEmployeeIndex;

